export const QA_NAME_LISTING_PROFILE_VIEWINGS_RETRY = 'listingViewingsRetry'

export const QA_NAME_LISTING_PROFILE_VIEWINGS_TABLE = 'listingViewings'

export const LISTING_PROFILE_VIEWINGS_SKELETON_ROWS = 3

export const LISTING_VIEWINGS_PAGE_SIZE = 20

export const LISTING_VIEWING_COLUMN_NAME = {
  Applicant: 'applicant',
  DateTime: 'start',
  Status: 'status',
}

// TODO: the tab runs on fixed columns until the backend registers its table
// config and the table loads it through useTableConfigLoader
export const LISTING_VIEWING_COLUMNS_CONFIG = {
  [LISTING_VIEWING_COLUMN_NAME.Applicant]: {
    index: 1,
    name: LISTING_VIEWING_COLUMN_NAME.Applicant,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsApplicantColumnKey',
    visible: true,
    width: 260,
  },
  [LISTING_VIEWING_COLUMN_NAME.DateTime]: {
    index: 0,
    name: LISTING_VIEWING_COLUMN_NAME.DateTime,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsDateTimeColumnKey',
    visible: true,
    width: 292,
  },
  [LISTING_VIEWING_COLUMN_NAME.Status]: {
    index: 2,
    name: LISTING_VIEWING_COLUMN_NAME.Status,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsStatusColumnKey',
    visible: true,
    width: 180,
  },
}

export const LISTING_VIEWINGS_STATE = {
  empty: 'empty',
  error: 'error',
  loading: 'loading',
  table: 'table',
}
